
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CustomerEdit from '@/components/Customer/CustomerEdit.vue';

@Component({
  components: {
    CustomerEdit,
  },
})
export default class CustomerEditButton extends Vue {
  @Prop(String) public id!: string;
  public showDialog = false;

  @Emit()
  public customerUpdated() {
    this.showDialog = false;
  }
}
